var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVoid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0498 17.3C14.0539 17.3 17.2998 14.0541 17.2998 10.05C17.2998 6.04598 14.0539 2.80005 10.0498 2.80005C6.04574 2.80005 2.7998 6.04598 2.7998 10.05C2.7998 14.0541 6.04574 17.3 10.0498 17.3ZM10.0498 18.8C14.8823 18.8 18.7998 14.8825 18.7998 10.05C18.7998 5.21756 14.8823 1.30005 10.0498 1.30005C5.21731 1.30005 1.2998 5.21756 1.2998 10.05C1.2998 14.8825 5.21731 18.8 10.0498 18.8Z",
    fill: "#1E2B3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.269588 19.7696C-0.0233055 19.4767 -0.0233055 19.0018 0.269588 18.7089L18.7089 0.269584C19.0018 -0.0233103 19.4767 -0.0233093 19.7696 0.269584C20.0625 0.562477 20.0625 1.03735 19.7696 1.33024L1.33025 19.7696C1.03735 20.0625 0.562481 20.0625 0.269588 19.7696Z",
    fill: "#1E2B3A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoid);
export default __webpack_public_path__ + "static/media/void.a72dff7f4e9dcc91ca72024a75eb1b6f.svg";
export { ForwardRef as ReactComponent };